import "@fancyapps/ui/dist/fancybox.css";
import { Fancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Swal from "sweetalert2";

import Gallery from "react-photo-gallery";
import { useParams } from "react-router-dom";
import { postDropbox, postStoreOrder } from "../../../../apis/cart";
import {
  faecResults,
  getFaceResultWithFolders,
} from "../../../../apis/facesearch";
import LogoAlgoWhite from "../../../../assets/images/logo-algo.png";
import LogoAlgoBlack from "../../../../assets/images/LogoAlgoBlack.png";
import { ThemeContext } from "../../../../components/App";
import Button from "../../../../components/common/Button";
import DialogWrapper from "../../../../components/common/Dialog";
import EmailPopUp from "../../../../components/common/EmailPopUp";
import ProductDetailsModal from "../../../../components/common/ProductDetailsModal";
import Share from "../../../../components/common/Share";
import SponsorBar from "../../../../components/common/SponsorBar";
import {
  DOWNLOAD_ORIGINAL_IMAGE,
  EVENT_WHERE_DROPBOX_NEEDED,
  EVENT_WITH_FACE_SEARCH_FOLDER,
  EVENT_WITH_SPECIAL_DIGITAL_PURCHASE,
  GUEST_UPLOAD_SLUG,
  HIGH_RES_DOMAIN,
  IMAGE_OG_SUBDOMAIN,
  IMAGE_RENDERER_SUBDOMAIN,
  LOWER_RES_DOMAIN,
  MY_PHOTOS,
  PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER,
  PHOTOGRAPHER_WITH_NO_BOTTOM_BRANDING,
  PRINT_IMAGE_SWAL_OBJECT,
} from "../../../../constants";
import {
  checkIsDeviceIOS,
  fireSingleDownloadGaEvent,
  printSuccessToast,
  privacyChangeDisabled,
} from "../../../../helper";
import { useEvent } from "../../../../Store/event";
import { useFavourites } from "../../../../Store/favourites";
import { useUploader } from "../../../../Store/upload";
import { useUser } from "../../../../Store/user";
import Loading from "../../../Loading";
import GalleryHeading from "../GalleryHeading";
import FaceSearchGalleryTabs from "../GalleryTabs/FaceSearchGalleryTabs";
import SelectedImage from "../SelectedImage";
import { galleryCaraouselIcons } from "./helpers/util";

const youtube_parser = (url) => {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
};

const getColumns = (size) => {
  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  let columns = 2;
  if (size === "small") columns = 2;
  if (vw >= 300 && size === "small") columns = 2;
  if (vw > 700 && size === "small") columns = 3;
  if (vw > 1200 && size === "small") columns = 6;
  if (size === "regular") columns = 2;
  if (vw >= 300 && size === "large") columns = 1;
  if (vw >= 300 && size === "regular") columns = 2;
  if (vw > 700 && size === "large") columns = 2;
  if (vw > 700 && size === "regular") columns = 3;
  if (vw > 1200 && size === "large") columns = 3;
  if (vw > 1200 && size === "regular") columns = 4;
  return columns;
};

const GUEST_UPLOADS_NAME = "Guest Uploads";

const GalleryWrapperFaceResults = ({
  onFavClickHandler,
  onFolderClickHandler,
  onFolderOptionsClickHandler,
  changeGallery,
  showFavouriteImages,
  isFoldersDrawerVisible,
  currentFaceSearchFolder,
  setCurrentFaceSearchFolder,
  faceSearchFolders,
  setFaceSearchFolders,
}) => {
  const { user, setUser } = useUser();
  const { guestUploadedImages } = useUploader();
  const isIosDevice = useMemo(checkIsDeviceIOS, []);
  const { eventName, slug } = useParams();
  const { currentFav, fancyboxFavClicked } = useFavourites();
  const theme = useContext(ThemeContext);

  const [selectAll, setSelectAll] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [privateMode, setPrivateMode] = useState(false);
  const [sharePopUp, setSharePopUp] = useState(false);
  const [shareUrl, setShareUrl] = useState();
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [cartPopUp, setCartPopUp] = useState(false);
  const [photo, setPhoto] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadAlertShown, setDownloadAlertShown] = useState(false);
  const [activeTab, setActiveTab] = useState(MY_PHOTOS.name);
  const [paginationLoader, setPaginationLoader] = useState(false);

  const ref = useRef();
  const loaderRef = useRef(null);
  const currentPage = useRef(1);
  const requestOnGoing = useRef(false);
  const galleryRef = useRef();

  ref.current = { photos };
  const eventDetails = useEvent().response;
  const iconsColor = theme === "dark" ? "white" : "#222";

  const addSponsorImages = (allPhotosFromAPI) => {
    // All images are loaded
    if (user.maxPage <= currentPage.current) {
      const totalAds = eventDetails.data.partnerShowcase.length;
      const adsPosition = Math.ceil(user.count / (totalAds + 1));
      eventDetails.data.partnerShowcase.forEach((el, index) => {
        allPhotosFromAPI.splice(adsPosition * (index + 1), 0, el);
      });
    } else {
      const totalAds = eventDetails.data.partnerShowcase.length;
      const adsPosition = Math.ceil(user.count / (totalAds + 1));

      eventDetails.data.partnerShowcase.forEach((el, index) => {
        if (allPhotosFromAPI.length > adsPosition * (index + 1)) {
          allPhotosFromAPI.splice(adsPosition * (index + 1), 0, el);
        }
      });
    }

    return allPhotosFromAPI;
  };

  const setGallery = (images, guestUploads = false) => {
    setLoading(true);
    let allPhotosFromAPI = images.map((i) => {
      if (i.isVideo) {
        let thumbUrl = `https://img.youtube.com/vi/${youtube_parser(
          decodeURI(i.url)
        )}/0.jpg`;
        return {
          src: decodeURI(i.url),
          thumb: thumbUrl,
          width: 640,
          height: 360,
          type: "video",
          "data-src": thumbUrl,
          key: i.id.toString(),
          originalImageObj: i,
          ...(guestUploads && { isPrivate: i.isPrivate }),
        };
      } else {
        let appendString,
          downloadSrc = "";
        if (
          !eventDetails.data.watermark ||
          !eventDetails.photographer.showWatermarkOnGallery
        ) {
          if (eventDetails.data.downloadSingleImageSize == "optimized")
            downloadSrc = i.url + "?v=" + i.version + "&w=1600";
          else
            downloadSrc =
              i.url
                .replace(LOWER_RES_DOMAIN, HIGH_RES_DOMAIN)
                .replace("+", "%2B") +
              "?v=" +
              i.version;
        } else {
          if (Array.isArray(eventDetails.data.watermark)) {
            appendString = "&mw=1&mwl=" + eventDetails.data.watermark.length;
            eventDetails.data.watermark.forEach((el, index) => {
              let wp = el.position ? el.position : "bottom-left";
              const isFullImageWatermark = el.fullWatermark;
              if (el.logoText) {
                appendString +=
                  `&wt${index}=` +
                  el.logoText +
                  `&wtc${index}=` +
                  el.fontColor +
                  `&wts${index}=` +
                  el.fontSize +
                  `&wp${index}=` +
                  wp +
                  `&wo${index}=` +
                  Number(el.opacity) * 0.1 +
                  `&wof${index}=` +
                  Number(el.xOffset) +
                  `,` +
                  Number(el.xOffset) +
                  `&wtf${index}=` +
                  el.font;
              }
              if (el.logoUrl) {
                let watermark = el.logoUrl.replace("watermark/", "");
                appendString +=
                  `&wm${index}=` +
                  watermark +
                  `&ws${index}=` +
                  el.logoScale +
                  `&wp${index}=` +
                  wp +
                  `&wof${index}=` +
                  Number(el.xOffset) +
                  `,` +
                  Number(el.yOffset) +
                  `&wo${index}=` +
                  Number(el.opacity) * 0.1 +
                  `&wfi${index}=` +
                  isFullImageWatermark;
              }
            });
            if (eventDetails.data.downloadSingleImageSize == "optimized")
              downloadSrc =
                i.url + "?v=" + i.version + "&w=1600" + appendString;
            else downloadSrc = i.url + "?v=" + i.version + "&w=1600";
          } else {
            let wp = eventDetails.data.watermark.position
              ? eventDetails.data.watermark.position
              : "bottom-left";
            const isFullImageWatermark =
              eventDetails.data.watermark.fullWatermark;
            if (eventDetails.data?.watermark?.logoText) {
              appendString =
                "&wt=" +
                eventDetails.data.watermark.logoText +
                "&wtc=" +
                eventDetails.data.watermark.fontColor +
                "&wts=" +
                eventDetails.data.watermark.fontSize +
                "&wp=" +
                wp +
                "&wo=" +
                Number(eventDetails.data.watermark.opacity) * 0.1 +
                "&wof=" +
                Number(eventDetails.data.watermark.xOffset) +
                "," +
                Number(eventDetails.data.watermark.xOffset) +
                "&wtf=" +
                eventDetails.data.watermark.font;
            }
            if (eventDetails.data?.watermark?.logoUrl) {
              let watermark = eventDetails.data.watermark.logoUrl.replace(
                "watermark/",
                ""
              );
              appendString =
                "&wm=" +
                watermark +
                "&ws=" +
                eventDetails.data.watermark.logoScale +
                "&wp=" +
                wp +
                "&wof=" +
                Number(eventDetails.data.watermark.xOffset) +
                "," +
                Number(eventDetails.data.watermark.yOffset) +
                "&wo=" +
                Number(eventDetails.data.watermark.opacity) * 0.1 +
                "&wfi=" +
                isFullImageWatermark;
            }
            if (eventDetails.data.downloadSingleImageSize == "optimized")
              downloadSrc =
                i.url + "?v=" + i.version + "&w=1600" + appendString;
            else downloadSrc = i.url + "?v=" + i.version + "&w=1600";
          }
        }
        return {
          src: appendString
            ? i.url.replace(
                "images.picsniff.com/assets-picsniff",
                LOWER_RES_DOMAIN
              ) +
              "?w=1600&v=" +
              i.version +
              appendString
            : i.url.replace(
                "images.picsniff.com/assets-picsniff",
                LOWER_RES_DOMAIN
              ) +
              "?w=1600&v=" +
              i.version,
          originalSrc: appendString
            ? i.url.replace(
                "images.picsniff.com/assets-picsniff",
                LOWER_RES_DOMAIN
              ) +
              "?v=" +
              i.version +
              appendString
            : i.url.replace(
                "images.picsniff.com/assets-picsniff",
                LOWER_RES_DOMAIN
              ) +
              "?v=" +
              i.version,
          downloadSrc: downloadSrc,
          width: Number(i.width),
          height: Number(i.height),
          key: i.id.toString(),
          ...(guestUploads && { isPrivate: i.isPrivate }),
          originalName: i.originalImageName,
          originalImageObj: i,
          printStoreSrc: i.url + "?v=" + i.version,
        };
      }
    });
    if (
      eventDetails.data.partnerShowcase &&
      !guestUploads &&
      allPhotosFromAPI.length &&
      eventDetails.data.partnerShowcase.length > 0
    ) {
      allPhotosFromAPI = addSponsorImages(allPhotosFromAPI);
    }
    setPhotos(allPhotosFromAPI);
    setLoading(false);
  };

  const onActiveTabChange = (activeTabName = MY_PHOTOS.name) => {
    setLoading(true);
    if (activeTabName === MY_PHOTOS.name) {
      setGallery(user.images, false);
      setPrivateMode(false);
    } else if (activeTabName === GUEST_UPLOADS_NAME) {
      setGallery(guestUploadedImages, true);
      setPrivateMode(true);
    } else {
      setLoading(false);
    }
  };

  const updateGuestUploadImages = () => {
    if (activeTab === GUEST_UPLOADS_NAME) {
      setGallery(guestUploadedImages, true);
    } else if (
      (EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
        PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
          eventDetails.photographer.id
        )) &&
      currentFaceSearchFolder?.folder_name === GUEST_UPLOADS_NAME
    ) {
      if (
        currentFaceSearchFolder.folder_name === GUEST_UPLOADS_NAME &&
        currentFaceSearchFolder.id === 1
      ) {
        setGallery([...guestUploadedImages], true);
      } else {
        setGallery([...user.images, ...guestUploadedImages], true);
      }
    }
    if (
      !faceSearchFolders.some((el) => el.folder_name === GUEST_UPLOADS_NAME) &&
      guestUploadedImages.length
    ) {
      setFaceSearchFolders((prev) => [
        ...prev,
        { folder_name: GUEST_UPLOADS_NAME, slug: GUEST_UPLOAD_SLUG, id: 1 },
      ]);
    }
  };

  useEffect(() => {
    updateGuestUploadImages();
  }, [guestUploadedImages]);

  useEffect(() => {
    if (user.search_id)
      if (currentFaceSearchFolder?.folder_name === GUEST_UPLOADS_NAME)
        if (currentFaceSearchFolder?.id === 1) {
          setGallery([...guestUploadedImages], true);
        } else setGallery([...user.images, ...guestUploadedImages], true);
      else setGallery(user.images);
  }, [user]);

  const printPhotoAlert = (fileUrl, key) =>
    Swal.fire({
      ...PRINT_IMAGE_SWAL_OBJECT(theme, fileUrl),
      preConfirm: async () => {
        try {
          await postDropbox(
            fileUrl.replace(IMAGE_RENDERER_SUBDOMAIN, IMAGE_OG_SUBDOMAIN)
          );
          const order = await postStoreOrder(
            user.accessToken,
            user.id,
            eventDetails.data.id,
            user.email,
            fileUrl.replace(IMAGE_RENDERER_SUBDOMAIN, IMAGE_OG_SUBDOMAIN),
            key,
            eventDetails.photographer.id
          );
          if (order.status.toString().startsWith("2")) {
            printSuccessToast();
            return;
          } else {
            window.Toast.fire({
              icon: "error",
              title: "Something went wrong",
            });
            return;
          }
        } catch (error) {
          console.log("Error", error);
          window.Toast.fire({
            icon: "error",
            title: "Something went wrong",
          });
          return;
        }
      },
    })
      .then(() => {})
      .catch((error) => {
        console.log("Error in swal while printing photos", error);
      });

  const galleryCaraouselItems = {
    slideshow: {
      type: "button",
      class: "fancybox__button--slideshow",
      label: "Start Slideshow",
      html: `<svg height="26" width="26" viewBox="0 0 24 24" tabindex="-1" style="stroke: ${iconsColor}">
                      <g><path color='${iconsColor}' d="M6 4v16"/><path color='${iconsColor}' d="M20 12L6 20"/><path color='${iconsColor}' d="M20 12L6 4"/></g>
                      <g><path color='${iconsColor}' d="M7 4v15M17 4v15"/></g>
                  </svg>`,
      click: function (event) {
        event.preventDefault();
        this.Slideshow.toggle();
      },
    },
    zoom: {
      type: "button",
      class: "fancybox__button--zoom",
      label: "Zoom",
      html: `<svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 24 24" stroke-width="1.5" style="stroke: ${iconsColor}">
      <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" color='${iconsColor}' />
    </svg>`,
      click: function (event) {
        event.preventDefault();
        const panzoom = this.fancybox.getSlide().Panzoom;

        if (panzoom) {
          panzoom.toggleZoom();
        }
      },
    },
    ...(eventDetails.data.downloadSingleImageSize !== "" &&
      eventDetails.data.downloadSingleImageSize !== null &&
      !!!eventDetails.data.isDownloadChargeable && {
        download: {
          type: "button",
          label: "Download",
          class: "fancybox__button--download",
          download: "true",
          html: `<svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 74 113"
          width="24"
          height="24"
          style="stroke: ${iconsColor}"
        >
          <path
            d="M34.559 92.3938C34.713 92.5478 34.8827 92.686 35.0635 92.8065L35.3028 92.9391L35.5819 93.0717L35.9009 93.1784L36.193 93.2711L36.1939 93.2711C36.6326 93.361 37.0842 93.361 37.5228 93.2711L37.8149 93.1784L38.1339 93.0717L38.4659 92.8992L38.7051 92.7666L38.7061 92.7666C38.8878 92.6461 39.0566 92.5079 39.2115 92.354L63.4329 68.1729C64.733 66.8737 64.733 64.7658 63.4329 63.4668C62.1337 62.1676 60.0267 62.1676 58.7268 63.4668L40.2349 81.9725L40.2349 3.3235C40.2349 1.48832 38.7465 -2.61322e-05 36.9113 -2.62927e-05C35.0762 -2.64531e-05 33.5878 1.48832 33.5878 3.3235L33.5878 81.9725L15.0959 63.4799C13.7958 62.1807 11.6888 62.1807 10.3898 63.4799C9.0897 64.78 9.0897 66.887 10.3898 68.186L34.559 92.3938Z"
            color='${iconsColor}' 
            fill='${iconsColor}'
          />
          <path
            d="M3.67645 112.987L70.1471 112.987C71.9776 112.987 73.4632 111.507 73.4706 109.676L73.4706 90.6392C73.4706 88.8031 71.9822 87.3157 70.1471 87.3157C68.3119 87.3157 66.8235 88.8031 66.8235 90.6392L66.8235 106.34L6.99998 106.34L6.99998 90.6392C6.99998 88.8031 5.51163 87.3157 3.67645 87.3157C1.84127 87.3157 0.352922 88.8031 0.352922 90.6392L0.35292 109.676C0.360339 111.507 1.84592 112.987 3.67645 112.987Z"
            color='${iconsColor}' 
            fill='${iconsColor}'
          />
        </svg>`,
          click: function (event) {
            event.stopPropagation();
            let url = this.fancybox.getSlide().downloadSrc;
            let filename = this.fancybox.getSlide().originalName;
            if (isIosDevice) {
              const downloadButtonClicked = () => {
                let a = document.createElement("a");
                document.body.appendChild(a);
                fireSingleDownloadGaEvent(filename, user.id);
                a.href =
                  eventDetails.data.downloadSingleImageSize ===
                  DOWNLOAD_ORIGINAL_IMAGE
                    ? url.replace(LOWER_RES_DOMAIN, HIGH_RES_DOMAIN)
                    : url;
                a.target = "_blank";
                setTimeout(() => a.click(), 100);
                document.body.removeChild(a);
              };
              if (!this.fancybox.options.downloadAlertShown) {
                this.fancybox.options.downloadAlertShown = true;
                setDownloadAlertShown(true);
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: "A new window with the photo will open. Press and hold the photo for option to save.",
                }).then(function (data) {
                  if (data.isConfirmed) {
                    downloadButtonClicked();
                  }
                });
              } else downloadButtonClicked();
              return;
            }
            url =
              eventDetails.data.downloadSingleImageSize ===
              DOWNLOAD_ORIGINAL_IMAGE
                ? url.replace(LOWER_RES_DOMAIN, HIGH_RES_DOMAIN)
                : url;
            fetch(url, {
              method: "GET",
            })
              .then((response) => {
                response.arrayBuffer().then(function (buffer) {
                  const url = window.URL.createObjectURL(new Blob([buffer]));
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", filename); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                  fireSingleDownloadGaEvent(filename, user.id);
                });
              })
              .catch((err) => {
                // console.log(err);
              });
          },
        },
      }),
    ...(!!eventDetails.data.showPrintStore &&
      !!eventDetails.photographer.showPrintStore && {
        cart: {
          type: "button",
          label: EVENT_WHERE_DROPBOX_NEEDED.includes(eventDetails.data.id)
            ? "Print image"
            : "Add To Cart",
          class: "fancybox__button--cart",
          html: EVENT_WHERE_DROPBOX_NEEDED.includes(eventDetails.data.id)
            ? `<svg xmlns="http://www.w3.org/2000/svg" fill='${iconsColor}' viewBox="0 0 24 24" stroke-width="1.5" style="stroke: ${iconsColor}" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
      </svg>`
            : `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            style="stroke: ${iconsColor}; height: 24px; width: 24px"
            viewBox="0 0 154 113"
          >
            <path
              d="M131.552 68.987L144.668 25.883H37.9757L51.092 68.987H131.552ZM114.298 81.7582C118.769 81.7582 122.818 83.5069 125.747 86.3342C128.678 89.1614 130.491 93.0665 130.491 97.3791C130.491 101.692 128.678 105.598 125.747 108.424C122.817 111.251 118.769 113 114.298 113C109.828 113 105.779 111.251 102.849 108.424C99.9189 105.597 98.1061 101.692 98.1061 97.3791C98.1061 93.0665 99.9187 89.1604 102.849 86.3342C105.78 83.507 109.828 81.7582 114.298 81.7582ZM120.23 91.657C118.713 90.1938 116.613 89.2879 114.298 89.2879C111.984 89.2879 109.884 90.1938 108.367 91.657C106.85 93.1201 105.911 95.1406 105.911 97.3791C105.911 99.6123 106.85 101.638 108.367 103.101C109.884 104.564 111.984 105.47 114.298 105.47C116.613 105.47 118.713 104.564 120.23 103.101C121.747 101.638 122.686 99.6122 122.686 97.3791C122.686 95.146 121.747 93.1202 120.23 91.657ZM68.3426 81.7582C72.813 81.7582 76.862 83.5069 79.7915 86.3342C82.7222 89.1614 84.535 93.0665 84.535 97.3791C84.535 101.692 82.7223 105.598 79.7915 108.424C76.8609 111.251 72.813 113 68.3426 113C63.8723 113 59.8233 111.251 56.8938 108.424C53.9631 105.597 52.1503 101.692 52.1503 97.3791C52.1503 93.0665 53.9629 89.1604 56.8938 86.3342C59.8244 83.507 63.8723 81.7582 68.3426 81.7582ZM74.2741 91.657C72.7574 90.1938 70.6575 89.2879 68.3426 89.2879C66.0278 89.2879 63.928 90.1938 62.4112 91.657C60.8945 93.1201 59.9554 95.1406 59.9554 97.3791C59.9554 99.6123 60.8945 101.638 62.4112 103.101C63.9279 104.564 66.0278 105.47 68.3426 105.47C70.6575 105.47 72.7573 104.564 74.2741 103.101C75.7908 101.638 76.7298 99.6122 76.7298 97.3791C76.7298 95.146 75.7908 93.1202 74.2741 91.657ZM28.956 22.9102L24.2738 7.52963H4.7849C2.62944 7.52963 0.882324 5.84419 0.882324 3.76477C0.882324 1.68535 2.62941 -7.76543e-05 4.7849 -7.76543e-05H27.186V0.0094029C28.8719 0.0094029 30.4213 1.06912 30.9191 2.70504L35.681 18.3531H149.871V18.3626C150.237 18.3626 150.604 18.4121 150.969 18.5164C153.031 19.1011 154.214 21.1889 153.604 23.1787L138.276 73.5502C137.896 75.2452 136.336 76.5177 134.462 76.5177H48.1842V76.5082C46.4982 76.5082 44.9488 75.4485 44.451 73.8125L29.1224 23.441C29.0569 23.2736 29.0001 23.0966 28.963 22.9112L28.956 22.9102Z"
              color='${iconsColor}' fill='${iconsColor}'
            />
          </svg>`,
          click: function (event) {
            event.stopPropagation();
            setPhoto(this.fancybox.getSlide());
            if (!user.accessToken) {
              setEmailPopUp(true);
            } else {
              if (EVENT_WHERE_DROPBOX_NEEDED.includes(eventDetails.data.id)) {
                printPhotoAlert(
                  this.fancybox.getSlide().printStoreSrc,
                  this.fancybox.getSlide().key
                );
              } else setCartPopUp(true);
            }
            this.fancybox.close();
          },
        },
      }),
    ...(privateMode && {
      privacy: {
        type: "button",
        label: "Privacy",
        class: "fancybox__button--download fancybox__button--privacy",
        html: `<svg
        aria-hidden='true'
        focusable='false'
        data-prefix='fas'
        data-icon='eye-slash'
        className='svg-inline--fa fa-eye-slash fa-w-20'
        role='img'
        viewBox='0 0 640 512'
        style="stroke: #00b7b8"
    >
        <path
            fill='#00b7b8'
            d='M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z'
        ></path>
    </svg>`,
        click: function async(event) {
          event.stopPropagation();
          privacyChangeDisabled();
        },
      },
    }),
    menu: {
      type: "button",
      label: "TOGGLE_THUMBS",
      class: "fancybox__button--thumbs",
      html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1" style="stroke: ${iconsColor}"><circle cx="4" cy="4" r="1" /><circle cx="12" cy="4" r="1" transform="rotate(90 12 4)"/><circle cx="20" cy="4" r="1" transform="rotate(90 20 4)"/><circle cx="4" cy="12" r="1" transform="rotate(90 4 12)"/><circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"/><circle cx="20" cy="12" r="1" transform="rotate(90 20 12)"/><circle cx="4" cy="20" r="1" transform="rotate(90 4 20)"/><circle cx="12" cy="20" r="1" transform="rotate(90 12 20)"/><circle cx="20" cy="20" r="1" transform="rotate(90 20 20)"/></svg>',
      click: function (event) {
        event.stopPropagation();

        const thumbs = this.fancybox.plugins.Thumbs;

        if (thumbs) {
          thumbs.toggle();
        }
      },
    },
    ...(!!eventDetails.data.showImageShare && {
      share: {
        type: "button",
        label: "Share",
        class: "fancybox__button--share",
        html: `<svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='share-alt'
          className='svg-inline--fa fa-share-alt fa-w-14'
          role='img'
          viewBox="0 0 96 110"
       
          style='height:18px; width:18px;stroke: ${iconsColor}'
        >
          <path
            d="M81.0937 79.918L81.0923 79.9111H80.6822C76.5061 79.9111 72.7421 81.6535 70.0474 84.4304L29.4984 58.8416C29.9137 57.4851 30.1451 56.0467 30.1451 54.5537C30.1451 53.057 29.9121 51.6175 29.4959 50.2589L69.5002 24.9925C72.2189 28.1092 76.223 30.0851 80.6827 30.0851C88.8536 30.0851 95.5 23.4499 95.5 15.29C95.5 7.13225 88.8517 0.5 80.6827 0.5C72.5073 0.5 65.8554 7.1339 65.8554 15.29C65.8554 16.505 66.0157 17.6798 66.2951 18.8035L25.9555 44.2803C23.2613 41.5017 19.4942 39.7588 15.3173 39.7588C7.14643 39.7588 0.5 46.394 0.5 54.5531C0.5 62.7084 7.14842 69.3399 15.3173 69.3399C19.4949 69.3399 23.262 67.596 25.9562 64.8191L66.505 90.4078C66.088 91.7682 65.8543 93.2109 65.8543 94.71C65.8543 102.868 72.5063 109.5 80.6816 109.5C88.8524 109.5 95.4989 102.866 95.4989 94.71C95.4998 86.6876 89.0753 80.1362 81.0937 79.918ZM80.6822 7.44025C85.0187 7.44025 88.5453 10.963 88.5453 15.2898C88.5453 19.621 85.0183 23.1444 80.6822 23.1444C76.3404 23.1444 72.8091 19.6196 72.8091 15.2898C72.8091 10.9636 76.3401 7.44025 80.6822 7.44025ZM15.3177 62.3994C10.981 62.3994 7.45461 58.8788 7.45461 54.5531C7.45461 50.2235 10.9816 46.6993 15.3177 46.6993C19.6595 46.6993 23.1908 50.2241 23.1908 54.5531C23.1908 58.8782 19.66 62.3994 15.3177 62.3994ZM80.6822 102.559C76.3402 102.559 72.8091 99.0358 72.8091 94.7096C72.8091 90.3778 76.3406 86.8516 80.6822 86.8516C85.0183 86.8516 88.5453 90.3772 88.5453 94.7096C88.5453 99.0363 85.0185 102.559 80.6822 102.559Z"
            fill='${iconsColor}'
          />
        </svg>`,
        click: function (event) {
          event.stopPropagation();
          const image = this.fancybox.getSlide().originalImageObj;
          setShareUrl(
            `${window.location.protocol}//${window.location.host}/view/${
              slug ? `${slug}/` : ""
            }${eventName}/${image.folderId}/image/${
              this.fancybox.getSlide().key
            }`
          );
          setSharePopUp(true);
        },
      },
    }),
    close: {
      type: "button",
      label: "Close",
      class: "fancybox__button--close",
      html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1" style="stroke: ${iconsColor}"><path color='${iconsColor}' d="M20 20L4 4m16 0L4 20"></path></svg>`,
      tabindex: 1,
      click: function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.fancybox.close();
      },
    },
    like: {
      type: "link",
      label: "Favourite",
      class: "fancybox__button--share fancybox__button--like",
      html: ` <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fas'
            data-icon='heart'
            className='svg-inline--fa fa-heart fa-w-20'
            role='img'
            viewBox='0 0 512 512'
            height='18'
            width='18'
            style="stroke: ${iconsColor};stroke-width: 40px;width: 30px;"
        >
            <path
                fill='${iconsColor}'
                d='M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z'
            ></path>
        </svg>`,
      tabindex: 1,
      click: async function (e) {
        if (!user.accessToken) {
          setEmailPopUp(true);
        } else {
          try {
            e.stopPropagation();

            const originalImageObj = this.fancybox.getSlide().originalImageObj;

            const isFav = originalImageObj?.favouriteList?.includes(
              currentFav.id
            );
            /**Remove image from fav */
            if (isFav) {
              e.target.firstElementChild.firstElementChild.style.fill =
                "transparent";
              const key = this.fancybox.getSlide()?.key;
              const photos = this.fancybox.options.folderImages;
              const currentPhotoIndex = photos.findIndex(
                (el) => el.key === key
              );
              const favList =
                photos[currentPhotoIndex].originalImageObj.favouriteList;
              const favListIndex = favList.findIndex(
                (el) => el === currentFav.id
              );
              favList.splice(favListIndex, 1);
              photos[currentPhotoIndex].originalImageObj.favouriteList =
                favList;
              const fancyboxFavIndex = originalImageObj.favouriteList.findIndex(
                (el) => el === currentFav.id
              );
              originalImageObj.favouriteList.splice(fancyboxFavClicked, 1);
              setPhotos(photos);
              const res = await fancyboxFavClicked(originalImageObj, true);
              if (res?.isError) {
                e.target.firstElementChild.firstElementChild.style.fill =
                  iconsColor;
                const key = this.fancybox.getSlide()?.key;
                const photos = this.fancybox.options.folderImages;
                const currentPhotoIndex = photos.findIndex(
                  (el) => el.key === key
                );

                if (
                  Array.isArray(
                    photos[currentPhotoIndex].originalImageObj.favouriteList
                  )
                )
                  photos[currentPhotoIndex].originalImageObj.favouriteList.push(
                    currentFav.id
                  );
                else
                  photos[currentPhotoIndex].originalImageObj.favouriteList = [
                    currentFav.id,
                  ];
                if (Array.isArray(originalImageObj?.favouriteList))
                  originalImageObj?.favouriteList?.push(currentFav.id);
                else {
                  originalImageObj.favouriteList = [currentFav.id];
                }
                setPhotos(photos);
              }
            } else {
              e.target.firstElementChild.firstElementChild.style.fill =
                iconsColor;
              const key = this.fancybox.getSlide()?.key;
              const photos = this.fancybox.options.folderImages;
              const currentPhotoIndex = photos.findIndex(
                (el) => el.key === key
              );

              if (
                Array.isArray(
                  photos[currentPhotoIndex].originalImageObj.favouriteList
                )
              )
                photos[currentPhotoIndex].originalImageObj.favouriteList.push(
                  currentFav.id
                );
              else
                photos[currentPhotoIndex].originalImageObj.favouriteList = [
                  currentFav.id,
                ];
              if (Array.isArray(originalImageObj?.favouriteList))
                originalImageObj?.favouriteList?.push(currentFav.id);
              else {
                originalImageObj.favouriteList = [currentFav.id];
              }
              setPhotos(photos);
              const res = await fancyboxFavClicked(originalImageObj, false);
              if (!res?.favId) {
                e.target.firstElementChild.firstElementChild.style.fill =
                  "transparent";
                const key = this.fancybox.getSlide()?.key;
                const photos = this.fancybox.options.folderImages;
                const currentPhotoIndex = photos.findIndex(
                  (el) => el.key === key
                );
                const favList =
                  photos[currentPhotoIndex].originalImageObj.favouriteList;
                const favListIndex = favList.findIndex(
                  (el) => el === currentFav.id
                );
                favList.splice(favListIndex, 1);
                photos[currentPhotoIndex].originalImageObj.favouriteList =
                  favList;
                const fancyboxFavIndex =
                  originalImageObj.favouriteList.findIndex(
                    (el) => el === currentFav.id
                  );
                originalImageObj.favouriteList.splice(fancyboxFavClicked, 1);
                setPhotos(photos);
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      },
    },
  };

  const FancyboxOptions = {
    infinite: false,
    autoFocus: true,
    preload: 2,
    trapFocus: true,
    Toolbar: {
      display: galleryCaraouselIcons,
      items: galleryCaraouselItems,
    },
    Thumbs: {
      autoStart: false,
    },
  };

  let galleryStyles = {
    direction:
      eventDetails.data.design.gridLayout === "horizontal" ? "row" : "column",
    //margin:Number(eventDetails.data.design.gridSpacing.replace('px','')),
    targetRowHeight:
      eventDetails.data.design.gridLayout === "horizontal"
        ? eventDetails.data.design.thumbnailSize === "regular"
          ? 350
          : eventDetails.data.design.thumbnailSize === "small"
          ? 200
          : 500
        : undefined,
    columns:
      eventDetails.data.design.gridLayout === "vertical"
        ? getColumns(eventDetails.data.design.thumbnailSize)
        : undefined,
  };
  const showFancyBox = useCallback(
    (index) => {
      Fancybox.defaults.Hash = false;
      let newAllPhotos = ref.current.photos
        .filter((p) => !p.isAd)
        .map((p) => {
          return { ...p, height: null, width: null };
        });

      const addColorToLikeButton = function () {
        let fancyBox = document.getElementsByClassName("fancybox__container");
        if (fancyBox.length) {
          fancyBox[0].oncontextmenu = (e) => {
            e.stopPropagation();
            e.preventDefault();
          };
        }
        let id;
        let isFav;
        if (![null, undefined].includes(this.pageIndex)) {
          id = this.pages[this.pageIndex].slides[0].key;
          isFav = this.pages[
            this.pageIndex
          ].slides[0]?.originalImageObj?.favouriteList?.includes(currentFav.id);
        } else {
          id = this.items[this.options.startIndex].key;
          isFav = this.items[
            this.options.startIndex
          ]?.originalImageObj.favouriteList?.includes(currentFav.id);
        }

        const toolbar = document.getElementsByClassName(
          "fancybox__toolbar__items"
        );
        if (toolbar.length) {
          const likeButon = toolbar[0].getElementsByClassName(
            "fancybox__button--like"
          );
          likeButon[0].firstElementChild.firstElementChild.style.fill = isFav
            ? iconsColor
            : "transparent";
        }
      };
      Fancybox.show(newAllPhotos, {
        ...FancyboxOptions,
        startIndex: index,
        folderImages: photos,
        downloadAlertShown: downloadAlertShown,
        once: {
          done: addColorToLikeButton,
          ready: () => {
            window.history.pushState(
              { fancyBoxOpen: true },
              undefined,
              "#fancyBoxOpen"
            );
          },
          shouldClose: () => {
            window.history.go(-1);
          },
        },
        Carousel: {
          on: {
            change: addColorToLikeButton,
          },
        },
      });
    },
    [photos, currentFav, downloadAlertShown]
  );

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
  };

  const imageRenderer = useCallback(
    ({ index, left, top, key, photo, direction, margin }) => (
      <SelectedImage
        key={key}
        margin={margin}
        index={index}
        photo={photo}
        left={left}
        top={top}
        onClick={photo.isAd ? () => {} : showFancyBox}
        direction={direction}
        onFavClickHandler={onFavClickHandler}
        privateMode={privateMode}
        folderId={photo.isAd ? "" : photo.originalImageObj.folderId}
        downloadAlertShown={downloadAlertShown}
        setDownloadAlertShown={setDownloadAlertShown}
        isAd={photo.isAd}
      />
    ),
    [user.images, currentFav, downloadAlertShown, privateMode]
  );

  const handleObserver = async (entries) => {
    const target = entries[0];
    if (
      target.isIntersecting &&
      photos.length &&
      !requestOnGoing.current &&
      !showFavouriteImages &&
      activeTab === MY_PHOTOS.name
    ) {
      currentPage.current = currentPage.current + 1;
      requestOnGoing.current = true;

      if (user?.maxPage < currentPage.current) return;
      setPaginationLoader(true);
      if (
        EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
        PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
          eventDetails.photographer.id
        )
      ) {
        try {
          const data = await getFaceResultWithFolders(
            user.search_id,
            currentFaceSearchFolder.id,
            currentPage.current
          );
          if (!data.error) {
            setUser((prev) => ({
              ...prev,
              images: [...prev.images, ...data.response.data],
            }));
          }
          // galleryRef.current.scrollBy({
          //   top: -10, // Scrolls up by 10 pixels
          //   left: 0, // No horizontal scrolling
          //   behavior: "smooth", // Smooth scrolling animation
          // });
        } catch (error) {
          console.error(error);
        } finally {
          setPaginationLoader(false);
          requestOnGoing.current = false;
        }
      } else {
        try {
          const data = await faecResults(
            user.search_id,
            eventDetails.data.id,
            currentPage.current
          );
          if (!data.error) {
            setUser((prev) => ({
              ...prev,
              images: [...prev.images, ...data.response.data],
            }));
          }
        } catch (error) {
          console.error(error);
        } finally {
          setPaginationLoader(false);
          requestOnGoing.current = false;
        }
      }
    }
  };

  const getFaceSearchImages = async () => {
    try {
      setLoading(true);
      window.scrollTo({
        top: galleryRef.current?.offsetTop,
        behavior: "smooth",
      });
      const data = await getFaceResultWithFolders(
        user.search_id,
        currentFaceSearchFolder.id
      );
      currentPage.current = 1;
      requestOnGoing.current = false;
      if (!data.error) {
        setUser((prev) => ({
          ...prev,
          images: data.response.data,
          maxPage: data.response?.meta?.last_page,
          count: data.response?.meta?.count,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onViewMoreClicked = () => {
    const index = faceSearchFolders.findIndex(
      (el) => el.id === currentFaceSearchFolder?.id
    );
    if (index + 1 < faceSearchFolders.length)
      setCurrentFaceSearchFolder(faceSearchFolders[index + 1]);
    else setCurrentFaceSearchFolder(faceSearchFolders[0]);
  };

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "500px",
      threshold: 0.5,
    };
    const observer = new IntersectionObserver(handleObserver, option);
    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => {
      observer.disconnect();
    };
  }, [user, photos]);

  const onBackClicked = (e) => {
    Fancybox.destroy();
  };

  useEffect(() => {
    window.addEventListener("popstate", onBackClicked);
    return () => {
      window.removeEventListener("popstate", onBackClicked);
    };
  }, []);

  useEffect(() => {
    if (
      (EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
        PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
          eventDetails.photographer.id
        )) &&
      currentFaceSearchFolder?.id &&
      user.search_id
    ) {
      if (currentFaceSearchFolder.id !== 1) {
        getFaceSearchImages();
      } else updateGuestUploadImages();
    }
  }, [currentFaceSearchFolder]);

  return (
    <div className="mx-auto" ref={galleryRef}>
      <div className="md:px-10 px-[24px] bg-[#fffefa] dark:bg-[#2d2d2d]">
        <GalleryHeading
          onFolderClickHandler={onFolderClickHandler}
          onFolderOptionsClickHandler={onFolderOptionsClickHandler}
          privateMode={privateMode}
          setPrivateMode={setPrivateMode}
          changeGallery={changeGallery}
          showFavouriteImages={showFavouriteImages}
          isFoldersDrawerVisible={isFoldersDrawerVisible}
          showFaceSearchImages={true}
        ></GalleryHeading>
      </div>
      {EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
      PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
        eventDetails.photographer.id
      ) ? (
        <FaceSearchGalleryTabs
          currentFaceSearchFolder={currentFaceSearchFolder}
          setCurrentFaceSearchFolder={setCurrentFaceSearchFolder}
          faceSearchFolders={faceSearchFolders}
        />
      ) : (
        <ul className="flex overflow-scroll scrollbar-hidden text-dark-gray1 dark:text-light-gray h-[45px] items-center mb-4 md:px-10 px-[24px] bg-[#fffefa] dark:bg-[#2d2d2d]">
          <li
            onClick={() => {
              if (activeTab !== MY_PHOTOS.name) {
                setActiveTab(MY_PHOTOS.name);
                onActiveTabChange(MY_PHOTOS.name);
              }
            }}
            className={
              activeTab === MY_PHOTOS.name
                ? "flex mr-[6px] md:mr-10 last:md:mr-0  dark:text-white text-black bg-[#fffefa] dark:bg-transparent text-sm md:text-base md:pr-[25px] py-[8px] pr-[21px] md:py-[10px]  rounded-lg whitespace-nowrap items-center font-medium"
                : "mr-[6px] md:mr-10 last:mr-0 md:pr-[25px] py-[8px] pr-[21px] md:py-[10px] whitespace-nowrap text-sm md:text-base items-center hover:dark:text-white dark:text-[#a5a5a5] hover:text-black text-[#1e1e1e99]"
            }
          >
            <button>
              {EVENT_WITH_SPECIAL_DIGITAL_PURCHASE.includes(
                eventDetails.data.id
              )
                ? "Click on cart icon to purchase images"
                : "My Photos".toUpperCase()}
            </button>
          </li>
          {guestUploadedImages.length > 0 && (
            <li
              onClick={() => {
                if (activeTab !== GUEST_UPLOADS_NAME) {
                  setActiveTab(GUEST_UPLOADS_NAME);
                  onActiveTabChange(GUEST_UPLOADS_NAME);
                }
              }}
              className={
                activeTab === GUEST_UPLOADS_NAME
                  ? "flex mr-[6px] md:mr-10 last:md:mr-0 dark:text-white text-black bg-[#fffefa] dark:bg-transparent text-sm md:text-base md:px-[25px] py-[8px] px-[21px] md:py-[10px]  rounded-lg whitespace-nowrap items-center font-medium"
                  : "mr-[6px] md:mr-10 last:mr-0 md:px-[25px] py-[8px] px-[21px] md:py-[10px] whitespace-nowrap text-sm md:text-base items-center hover:dark:text-white dark:text-[#a5a5a5] hover:text-black text-[#1e1e1e99]"
              }
            >
              <button>{"Guest Uploads".toUpperCase()}</button>
            </li>
          )}
        </ul>
      )}
      {/* <GalleryTabs active={folder.id}></GalleryTabs> */}
      {loading && !paginationLoader ? (
        <Loading />
      ) : photos.length > 0 ? (
        <div className=" md:px-10 px-[24px]">
          <Gallery
            {...galleryStyles}
            photos={photos}
            margin={
              eventDetails.data.design.gridSpacing === "small"
                ? 3
                : eventDetails.data.design.gridSpacing === "regular"
                ? 6
                : 9
            }
            renderImage={imageRenderer}
          />
          {/* <SelectPhotos /> */}
        </div>
      ) : loading ? (
        <Loading />
      ) : (
        <div>No Photos in this folder</div>
      )}
      {paginationLoader ? (
        <div>
          <Loading height="!h-fit" />{" "}
        </div>
      ) : (
        <></>
      )}
      <div id="loaderRef" ref={loaderRef} />
      {(EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
        PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
          eventDetails.photographer.id
        )) &&
      paginationLoader ? (
        <></>
      ) : (
        <div
          className={`flex justify-center items-center ${
            EVENT_WITH_FACE_SEARCH_FOLDER.includes(eventDetails.data.id) ||
            PHOTOGRAPHER_WITH_FACE_SEARCH_FOLDER.includes(
              eventDetails.photographer.id
            )
              ? "pb-4 "
              : "invisible opacity-0 "
          }pt-4`}
        >
          <Button onClick={onViewMoreClicked} text="View More" />
        </div>
      )}
      {eventDetails.data.sponsorDetails &&
      Object.keys(eventDetails.data.sponsorDetails).length ? (
        <SponsorBar />
      ) : (
        <></>
      )}
      {PHOTOGRAPHER_WITH_NO_BOTTOM_BRANDING.includes(
        eventDetails.photographer.id
      ) || eventDetails.photographer?.planName?.includes("Premium") ? (
        <></>
      ) : (
        <div className="mt-4 pb-4 text-dark-gray1 dark:text-light-gray flex justify-center items-center ">
          <span>Powered by</span>
          <a href="https://www.algomage.com" target="_blank">
            <img
              src={theme === "dark" ? LogoAlgoWhite : LogoAlgoBlack}
              className={theme === "dark" ? "ml-4" : "-ml-4 -mt-1"}
              width={180}
            />
          </a>
        </div>
      )}
      <DialogWrapper
        open={sharePopUp}
        close={() => {
          setSharePopUp(false);
        }}
        description=""
        title="Share"
      >
        <Share shareUrl={shareUrl} />
      </DialogWrapper>
      <DialogWrapper
        open={emailPopUp}
        close={() => {
          setEmailPopUp(false);
        }}
        description=""
        title="Login"
      >
        <EmailPopUp
          close={(e) => {
            setEmailPopUp(e);
          }}
        />
      </DialogWrapper>
      {!EVENT_WHERE_DROPBOX_NEEDED.includes(eventDetails.data.id) && (
        <ProductDetailsModal
          open={cartPopUp}
          close={() => {
            setCartPopUp(false);
          }}
          photo={photo}
        />
      )}
    </div>
  );
};

export default GalleryWrapperFaceResults;
